import { FormEvent, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import AppContext from '../../contexts/AppContext';
import DataContext from '../../contexts/DataContext';
import ConfigContext from '../../contexts/ConfigContext';

import Button from '../../components/Button';
import Input from '../../components/Input';

import Slide from '../components/Slide';
import { email as emailPageData } from '../data/pages';
import { saveEmail, validateEmail } from '../utils';
import AnswerOptions from '../../components/AnswerOptions';

export default function Email() {
  const {
    currentPageIndex,
    setCurrentPageIndex,
    getDataForNem3,
    isNem3,
    savedEmail,
    setSavedEmail,
  } = useContext(AppContext);
  const { data, updateData } = useContext(DataContext);
  const { isDebrandedVersion } = useContext(ConfigContext);

  const [haveError, setHaveError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { heading, nextPage, options } = emailPageData;
  const { email, sendEmailLink } = data;

  useEffect(() => {
    updateData({ ...data, sendEmailLink: true });
    getDataForNem3();
  }, []);

  useEffect(() => {
    getDataForNem3();
  }, [isNem3]);

  const handleEmailChange = (event: FormEvent<HTMLInputElement>) => {
    const email = event.currentTarget.value;
    if (validateEmail(email)) {
      updateData({
        ...data,
        email,
      });
      setHaveError(false);
    } else {
      updateData({
        ...data,
        email,
      });
      setHaveError(true);
    }
  };

  return (
    <>
      <Slide heading={heading} />
      <p className="mt-[30px] md:mt-10 text-[17px] short:!text-[16px] md:text-[18px]">Email</p>
      <Input
        name="email"
        type="email"
        placeholder="Email address"
        onChange={handleEmailChange}
        onBlur={() => {
          if (email !== savedEmail) {
            saveEmail(email, data);
            setSavedEmail(email);
          }
        }}
        className="mt-3 md:mt-4 mb-6 md:mb-10 text-[#3c3c3c] md:w-[400px]"
        errorMessage="Enter a valid email."
        haveError={haveError}
        defaultValue={email}
      />
      {!isDebrandedVersion && (
        <AnswerOptions
          defaultValue={sendEmailLink}
          options={options}
          updateSelectedOption={(newValue: boolean) => {
            const value = sendEmailLink === newValue ? false : newValue;
            updateData({ ...data, sendEmailLink: value });
          }}
        />
      )}
      <div className="mt-[50px] md:mt-[60px]">
        <Button
          action={() => {
            dataLayer.push({ event: 'seform_email_entered' });

            updateData({
              ...data,
              email,
              sendEmailLink,
            });

            // set current page index
            setCurrentPageIndex(currentPageIndex + 1);

            // update page param and navigate to next page
            searchParams.set('page', nextPage);
            setSearchParams(searchParams);
          }}
          disabled={haveError || !email}
          data-zuko-id="emailLink_continue"
        />
      </div>
    </>
  );
}
